export function getdata() {
	let obj = {
		
			headData: [{
					title: "项目",
					prop:'title',
					width: "300px",
					custom: true,
				},
				{
					title: "行次",
					prop: "grade",
					custom: true,
					width: "100px"
				},
				{
					title:'本年累计金额',
					prop:'cwbbxqykjzz_4_x_1',
					width: "200px",
					custom: true,
				},
				{
					title:'上年金额',
					prop:'cwbbxqykjzz_4_x_2',
					width: "200px",
					custom: true,
				},
			],
			tableData: [{
					title: "一、营业收入",
					grade: "1",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					title: "减：营业成本",
					grade: "2",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "营业税金及附加",
					grade: "3",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：消费税",
					grade: "4",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "营业税",
					grade: "5",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "城市维护建设税",
					grade: "6",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "资源税",
					grade: "7",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "土地增值税",
					grade: "8",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "城镇土地使用税、房产税、车船税、印花税",
					grade: "9",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "教育费附加、矿产资源补偿费、排污费",
					grade: "10",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: " 销售费用",
					grade: "11",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：商品维修费",
					grade: "12",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "广告费和业务宣传费",
					grade: "13",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: " 管理费用",
					grade: "14",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：开办费",
					grade: "15",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "业务招待费",
					grade: "16",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "研究费用",
					grade: "17",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "财务费用",
					grade: "18",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：利息费用（收入以“-”号填列）",
					grade: "19",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "加：投资收益（损失以“-”号填列）",
					grade: "20",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "二、营业利润（亏损以“-”号填列）",
					grade: "21",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "加：营业外收入",
					grade: "22",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：政府补助",
					grade: "23",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_23_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_23_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "减：营业外支出",
					grade: "24",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_24_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_24_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：坏账损失",
					grade: "25",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_25_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_25_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "无法收回的长期债券投资损失",
					grade: "26",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_26_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_26_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "无法收回的长期股权投资损失",
					grade: "27",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_27_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_27_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "自然灾害等不可抗力因素造成的损失",
					grade: "28",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "税收滞纳金",
					grade: "29",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_29_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_29_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "三、利润总额（亏损总额以“-”号填列）",
					grade: "30",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_30_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_30_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "减：所得税费用",
					grade: "31",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_31_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_31_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "四、净利润（净亏损以“-”号填列）",
					grade: "32",
					disabledcwbbxqykjzz_4_x_1:false,
					disabledcwbbxqykjzz_4_x_2:false,
					cwbbxqykjzz_4_x_1: {
						cellCode:"cwbbxqykjzz_4_32_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_4_x_2: {
						cellCode:"cwbbxqykjzz_4_32_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				}
			]
		
	}
	return obj
}
